import React from 'react';
import './styles/antd.less';
import './styles/app.scss';
import { Menu } from 'antd';
import Listings from './components/Listings';
import Orders from './components/Orders';

class App extends React.Component {
  state = {
    view: 'listings',
    hasError: false
  };

  componentDidCatch(err) {
    console.log(err);
    this.setState({ hasError: true });
  }

  handleMenuClick = e => {
    this.setState({
      view: e.key
    });
  };

  render() {
    const { hasError, view } = this.state;
    if (hasError) {
      return (
        <div>
          <h1>An Error has Occured</h1>
        </div>
      );
    }

    return (
      <div>
        <Menu
          onClick={this.handleMenuClick}
          selectedKeys={[view]}
          mode="horizontal"
        >
          <Menu.Item key="listings">Listings</Menu.Item>
          <Menu.Item key="orders">Orders</Menu.Item>
        </Menu>
        {view === 'listings' ? <Listings /> : <Orders />}
      </div>
    );
  }
}

export default App;
